import { render, staticRenderFns } from "./VvCheckboxBubble.vue?vue&type=template&id=5bc1a66c&scoped=true&"
import script from "./VvCheckboxBubble.vue?vue&type=script&lang=js&"
export * from "./VvCheckboxBubble.vue?vue&type=script&lang=js&"
import style0 from "./VvCheckboxBubble.vue?vue&type=style&index=0&id=5bc1a66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc1a66c",
  null
  
)

export default component.exports